import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;

export const Schema = (settings) => Yup.object().shape({
    emailAddress: Yup.string()
        .email("Bitte geben Sie eine gültige E-Mail-Adresse an")
        .required("Angabe ist erforderlich"),
    phoneNumber: Yup.string()
        .matches(RegExp(settings.applicationPhoneNumberRegex), "Ungültige Telefonnummer"),
});

export const ContactSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>

            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mail*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="E-Mail eingeben"
                    type="email"
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.emailAddress && !errors.emailAddress}
                    isInvalid={touched.emailAddress && errors.emailAddress}
                    maxLength={settings.emailInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPhoneNumber">
                <Form.Label>Telefon</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Telefon eingeben"
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.phoneNumber && !errors.phoneNumber}
                    isInvalid={errors.phoneNumber}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.phoneNumber}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};